import { ANGULAR_INIT } from "~/store/action_types";

const instance = (state = null, action) => {
  switch (action.type) {
    case ANGULAR_INIT: {
      if (action.response && action.response.instance_id) {
        return action.response.instance_id;
      }
      return state;
    }
    default:
      return state;
  }
};

export default instance;
